var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import range from 'lodash.range';
import withDesign from '../../../hocs/withDesign';
import { Column, Row } from '../../layout/Container';
import StepIndicator from './components/atoms/StepIndicator';
import StepperLabel from './components/atoms/StepperLabel';
import StepSeparator from './components/atoms/StepSeparator';
var RenderStepper = function (_a) {
    var steps = _a.steps, renderStepIndicator = _a.renderStepIndicator, renderDivider = _a.renderDivider, renderStepperLabel = _a.renderStepperLabel, props = __rest(_a, ["steps", "renderStepIndicator", "renderDivider", "renderStepperLabel"]);
    var children = range(steps).reduce(function (arr, i) {
        arr.push(renderStepIndicator(i + 1));
        if (i < steps - 1) {
            arr.push(renderDivider(i + 1));
        }
        return arr;
    }, []);
    return (_jsxs(Column, { children: [renderStepperLabel(), _jsx(Row, __assign({}, props, { children: children }), "stepper-content")] }));
};
var StepperComponent = function (_a) {
    var currentStep = _a.currentStep, steps = _a.steps, showLabel = _a.showLabel, design = _a.design, components = _a.components, props = __rest(_a, ["currentStep", "steps", "showLabel", "design", "components"]);
    return (_jsx(RenderStepper, __assign({ steps: steps, renderStepperLabel: function () {
            return !showLabel ? null : (_jsx(Row, __assign({ design: components === null || components === void 0 ? void 0 : components.label }, { children: _jsx(StepperLabel, { design: components === null || components === void 0 ? void 0 : components.label, currentStep: currentStep, steps: steps }) }), components === null || components === void 0 ? void 0 : components.label));
        }, renderStepIndicator: function (stepNumber) {
            if (stepNumber < currentStep) {
                return (_jsx(StepIndicator, __assign({ design: components === null || components === void 0 ? void 0 : components.doneIndicator }, { children: stepNumber }), "step_".concat(stepNumber)));
            }
            else if (stepNumber === currentStep) {
                return (_jsx(StepIndicator, __assign({ design: components === null || components === void 0 ? void 0 : components.currentIndicator }, { children: stepNumber }), "step_".concat(stepNumber)));
            }
            else {
                return (_jsx(StepIndicator, __assign({ design: components === null || components === void 0 ? void 0 : components.nextIndicator }, { children: stepNumber }), "step_".concat(stepNumber)));
            }
        }, renderDivider: function (stepNumber) {
            if (stepNumber < currentStep) {
                return (_jsx(StepSeparator, { design: components === null || components === void 0 ? void 0 : components.doneSeparator }, "separator_".concat(stepNumber)));
            }
            else {
                return (_jsx(StepSeparator, { design: components === null || components === void 0 ? void 0 : components.nextSeparator }, "sepataror_".concat(stepNumber)));
            }
        } }, props)));
};
StepperComponent.displayName = 'StepperComponent';
StepperComponent.defaultProps = {};
export * from './Stepper.types';
export var Stepper = withDesign(StepperComponent);
